import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Textfield } from '@digdir/designsystemet-react';

import { useAdjustParametersFormContext } from '../../utils';
import { parseNorwegianFormattedNumber } from '../../../../../../utils/utils';

interface ExpertValueProps {
  unit: string;
  parameterKey: string;
}

export const ExpertValue: FC<ExpertValueProps> = ({ parameterKey, unit }) => {
  const { t } = useTranslation();
  const { register, formState, trigger } = useAdjustParametersFormContext();

  const expertValueLabel = `${t(`register.parameters.type.${parameterKey}`)}-${t('register.parameters.new')}`;

  return (
    <Textfield
      type="text"
      inputMode="decimal"
      aria-label={expertValueLabel || ''}
      suffix={unit === '' ? undefined : unit}
      error={!!formState.errors?.[`${parameterKey}`]?.message}
      {...register(`${parameterKey}.expertValue`, {
        setValueAs: (value) => parseNorwegianFormattedNumber(value),
        onChange: () => {
          formState.isSubmitted && trigger();
        }
      })}
    />
  );
};
